import { cn } from "@d12labs/utils";

/** First letters of the first two words, uppercased (e.g. "Ada Lovelace" → "AL"). */
export function initials(name: string): string {
	return name
		.split(/\s+/)
		.slice(0, 2)
		.map((w) => w[0] ?? "")
		.join("")
		.toUpperCase();
}

// Hues sampled from the chart palette family so avatars sit in the same world as
// the score charts. Picked deterministically from the name so a person keeps the
// same color everywhere they appear.
const HUES = [220, 175, 35, 280, 200, 330];

function hashName(name: string): number {
	let h = 0;
	for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
	return Math.abs(h);
}

const SIZES = {
	md: "h-8 w-8 text-xs",
	lg: "h-14 w-14 text-lg",
	xl: "h-[72px] w-[72px] text-[22px]",
} as const;

/** Initials avatar with a stable per-name color. */
export function Avatar({
	name,
	size = "md",
	className,
}: {
	name: string;
	size?: keyof typeof SIZES;
	className?: string;
}) {
	const hue = HUES[hashName(name) % HUES.length];
	return (
		<span
			className={cn(
				"inline-flex flex-none items-center justify-center rounded-full font-semibold",
				SIZES[size],
				className,
			)}
			style={{ background: `oklch(0.28 0.05 ${hue})`, color: `oklch(0.85 0.05 ${hue})` }}
		>
			{initials(name)}
		</span>
	);
}
